<script>
import Layout from "@/components/common/Layout.vue";
import NewsMixin from "@/mixins/NewsMixin";
import Icon from "@/components/icon/Icon.vue";

export default {
	name: "NewsDetailPage" ,
	components: {Icon, Layout},
	mixins: [NewsMixin],
	data() {
		return {
			id: this.$route.params.id,
			post: {}
		}
	},
	methods: {
		getPost(postId) {
			this.post = this.getNewsList.find(item => item.id === postId);
		}
	},
	mounted() {
		this.getPost(this.id);
	}
}
</script>

<template>
	<Layout header-class="header-left-align" nav-alignment="left">
		<div class="rn-blog-details-area">
			<div class="post-page-banner" style="padding-top: 60px">
				<div class="container">
					<div class="row">
						<div class="col-12">
							<div class="content text-center">
								<div class="page-title">
									<h3 v-html="post.title"/>
								</div>
								<ul class="rn-meta-list">
									<li v-if="post.publishedAt">
										<Icon name="calendar" class="size-20"/> {{ post.publishedAt }}
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="blog-details-content rn-section-gapBottom">
				<div class="container">
					<div class="content">
						<p v-html="post.body"/>
					</div>
				</div>
			</div>
		</div>

	</Layout>
</template>

<style scoped lang="scss">
:deep(li) {
	list-style: none;
	display: flex;
	align-items: center;
	justify-content: center;
	i {
		margin-top: -4px;
		margin-right: 10px;
	}
}
</style>
